import { useEffect, useState } from "react";
import { HbrCancel, HbrShareIcon } from "../MyCustomsvgicons";


const ShareForm = ({callToAction, url, title, formTitle, closeForm, showMoreOptions}) => {
    const [copied, setCopied] = useState(false);

    const handleCopyLink=async()=>{
        if(navigator.clipboard){
            try{
                await navigator.clipboard.writeText(`${callToAction}\n\n${url}`);
                setCopied(true);
            }catch{
            }
        }
    };

    useEffect(()=>{
        if(copied){
            const timeid = setTimeout(() => {
                setCopied(false);
           }, 2000);

           return ()=>{
            clearTimeout(timeid);
           }
        }
    },[copied]);

    const handleMoreOptions=async()=>{
        if(navigator.share){
            try{
                await navigator.share({
                    title: title,
                    text: callToAction,
                    url: url,
                });
            }catch{
            }
        }
        closeForm();
    };

    return ( 
        <div className="customshareform flex-column2">
            <div className="flex-spacearound" style={{width: "100%"}}>
                <h4>{formTitle}</h4>
            <HbrCancel width={"2em"} height={"2em"} fillColour={"black"} handleClick={()=>closeForm()}/>
            </div>
           
           <div style={{borderRadius:"30px", backgroundColor: "green", width:"80%"}}>
            <p style={{fontWeight:"bold", padding:"10px", color:"white"}}>{callToAction}</p>
           </div>
           

            <div className="flex-spacearound" style={{width:"100%"}}> 
                <h4 style={{width:"80%",overflow:"hidden"}}>
                    {url}
                </h4>
                <button onClick={()=>handleCopyLink()} style={{border:"none", backgroundColor:"#eb268f", borderRadius:"30px", fontWeight:"bold", color:"white", padding:"10px", cursor: "pointer"}}>
                    {`${!copied ? 'copy':'copied ✔'}`}
                </button>
                
            </div>

            {showMoreOptions && (
                <div className="flex-row2">
                <h4>More options</h4>
                <HbrShareIcon width={"2em"} height={"2em"} fillColour={"black"} handleClick={()=>handleMoreOptions()}/>
                </div>
            )}
          
        </div>
     );
}
export default ShareForm;